import React, { useState } from "react"
import { Link, graphql } from "gatsby"
import { Close } from "@/components/svg/Close"
import MainLayout from "@/layouts/MainLayout"
import findImage from "@/utils/find-image"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import SharedHead from "@/components/SharedHead"
import useHeadTranslation from "@/hooks/use-head-translation"

export const Head = props => {
  const { t } = useHeadTranslation(props)

  return (
    <SharedHead
      {...props}
      title={t("i-miss-you.title")}
      description={t("i-miss-you.description")}
      noIndex={true}
    />
  )
}

const IMissYouPage = ({ data }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <MainLayout showNav={false} showFooter={false} showDocsBot={false}>
      <div className="i-miss-you-page">
        <div className="header container-fluid">
          <div className="logo-container">
            <svg
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="56" height="56" fill="#463DFB" />
              <path
                d="M31.7119 14.7907C31.1891 14.7907 30.7636 15.2205 30.7636 15.7485C30.7636 16.2765 31.1891 16.7063 31.7119 16.7063C32.2347 16.7063 32.6603 16.2765 32.6603 15.7485C32.6603 15.2205 32.2347 14.7907 31.7119 14.7907Z"
                fill="white"
              />
              <path
                d="M31.7119 19.2051C31.1891 19.2051 30.7636 19.6349 30.7636 20.1629C30.7636 20.6909 31.1891 21.1207 31.7119 21.1207C32.2347 21.1207 32.6603 20.6909 32.6603 20.1629C32.6603 19.6349 32.2347 19.2051 31.7119 19.2051Z"
                fill="white"
              />
              <path
                d="M31.7119 23.6192C31.1891 23.6192 30.7636 24.049 30.7636 24.577C30.7636 25.105 31.1891 25.5348 31.7119 25.5348C32.2347 25.5348 32.6603 25.105 32.6603 24.577C32.6603 24.049 32.2347 23.6192 31.7119 23.6192Z"
                fill="white"
              />
              <path
                d="M36.1688 14.7907C35.646 14.7907 35.2205 15.2205 35.2205 15.7485C35.2205 16.2765 35.646 16.7063 36.1688 16.7063C36.6916 16.7063 37.1171 16.2765 37.1171 15.7485C37.1171 15.2205 36.6916 14.7907 36.1688 14.7907Z"
                fill="white"
              />
              <path
                d="M36.1692 19.2051C35.6464 19.2051 35.2209 19.6349 35.2209 20.1629C35.2209 20.6909 35.6464 21.1207 36.1692 21.1207C36.692 21.1207 37.1176 20.6909 37.1176 20.1629C37.1176 19.6349 36.692 19.2051 36.1692 19.2051Z"
                fill="white"
              />
              <path
                d="M36.1692 23.6192C35.6464 23.6192 35.2209 24.049 35.2209 24.577C35.2209 25.105 35.6464 25.5348 36.1692 25.5348C36.692 25.5348 37.1176 25.105 37.1176 24.577C37.1176 24.049 36.692 23.6192 36.1692 23.6192Z"
                fill="white"
              />
              <path
                d="M40.5469 14.7907C40.0241 14.7907 39.5986 15.2205 39.5986 15.7485C39.5986 16.2765 40.0241 16.7063 40.5469 16.7063C41.0697 16.7063 41.4953 16.2765 41.4953 15.7485C41.5014 15.2205 41.0758 14.7907 40.5469 14.7907Z"
                fill="white"
              />
              <path
                d="M40.5474 19.2051C40.0246 19.2051 39.5991 19.6349 39.5991 20.1629C39.5991 20.6909 40.0246 21.1207 40.5474 21.1207C41.0702 21.1207 41.4957 20.6909 41.4957 20.1629C41.5018 19.6349 41.0763 19.2051 40.5474 19.2051Z"
                fill="white"
              />
              <path
                d="M40.5474 23.6192C40.0246 23.6192 39.5991 24.049 39.5991 24.577C39.5991 25.105 40.0246 25.5348 40.5474 25.5348C41.0702 25.5348 41.4957 25.105 41.4957 24.577C41.4957 24.049 41.0763 23.6192 40.5474 23.6192Z"
                fill="white"
              />
              <path
                d="M19.5526 14.5833C22.6189 14.5836 25.1044 17.0697 25.1044 20.1361L25.1044 35.5794C25.1044 38.6458 22.6189 41.1319 19.5526 41.1322C16.4861 41.1322 13.9999 38.6459 13.9999 35.5794L13.9999 20.1361C13.9999 17.0696 16.4861 14.5833 19.5526 14.5833ZM19.6464 31.4788C17.4579 31.4271 15.6389 33.1859 15.5878 35.4056C15.5368 37.6252 17.2705 39.4699 19.4589 39.5218C21.6472 39.5734 23.4665 37.8147 23.5175 35.5951C23.5725 33.3756 21.8387 31.5308 19.6464 31.4788ZM20.8807 36.9398L18.2294 36.9398L18.2294 34.2503L20.8807 34.2503L20.8807 36.9398ZM19.7303 16.2894C17.5407 16.2356 15.7251 17.9932 15.6757 20.2142C15.6264 22.435 17.3621 24.2785 19.5516 24.3324C21.7411 24.3859 23.5559 22.6294 23.6053 20.4085C23.6547 18.1876 21.92 16.3432 19.7303 16.2894Z"
                fill="white"
              />
              <path
                d="M42.0003 41.4167L30.3099 41.4167L30.3099 29.6101L42.0003 29.6101L42.0003 41.4167ZM32.6888 38.1746L39.6243 38.1746L39.6243 36.7136L32.6888 36.7136L32.6888 38.1746ZM32.6888 32.8455L32.6888 34.3074L39.6243 34.3074L39.6243 32.8455L32.6888 32.8455Z"
                fill="white"
              />
            </svg>
          </div>
          <h1 className="title">Roses are red. Capsule is blue.</h1>
          <p className="subtitle">
            You left me after your trial. Now log in. Again.
          </p>
          <div className="button-group">
            <Link
              to="https://app.capsulecrm.com/siteaddress/goto"
              className="button primary mb-4"
              target="_blank"
            >
              Log back in
            </Link>
            <Link to="/contact-sales" className="button secondary mr-2 mb-4">
              or talk to Sales
            </Link>
          </div>
        </div>
        <div className="content">
          <div className="letter">
            <div className="letter-content">
              <svg
                width="30"
                height="35"
                viewBox="0 0 30 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  position: "absolute",
                  top: "80px",
                  right: "-40px",
                  transform: "rotate(-15deg)",
                }}
              >
                <path
                  d="M1.51922 2.78355C5.87764 -3.97557 11.7837 4.33662 16.7655 10.6528C17.6295 6.77012 19.4834 1.64063 23.4426 1.21955C32.0446 0.29537 30.3822 27.0529 28.4408 34.7034C15.8358 29.1856 -5.93987 14.344 1.51922 2.78355Z"
                  fill="#C8C5FE"
                />
              </svg>

              <p>
                Whether you're seeing what else is out there or just got busy
                and forgot about me, it really doesn't matter - it's all in the
                past now.
              </p>

              <p>
                Please, please, please,{" "}
                <Link
                  to="https://app.capsulecrm.com/siteaddress/goto"
                  className="link"
                  target="_blank"
                >
                  just log back in
                </Link>
                . It'll be like nothing ever happened.*
              </p>

              <p className="footnote">
                *Literally, though, because I kept your account exactly how you
                left it.
              </p>

              <div className="flex-container">
                <div>
                  <h2>
                    Won't you just log in? It'll be worth your while &lt;3
                  </h2>

                  <p>
                    When you signed up, it was love at first click. And now
                    you're back... my servers are racing just thinking about
                    you.
                  </p>
                </div>
                <div>
                  <div
                    onClick={() => setShowModal(true)}
                    style={{ cursor: "pointer" }}
                  >
                    <GatsbyImage
                      className=""
                      image={getImage(
                        findImage(data.jiltedImages, "heartbreak_playlist"),
                      )}
                      style={{ width: "220px" }}
                    />
                  </div>
                </div>
              </div>

              <p>
                I know you had other options, and maybe they seemed cooler or
                more impressive or whatever, but I always felt like we clicked.
                And maybe I'm delusional, but do you feel it too?
              </p>

              <p>
                If there's even the tiniest chance you've been missing me,
                well... I'm still here. Waiting. No pressure. (Okay, a little
                pressure.) So... what do you think? Are you ready to log back
                in? Or would you prefer to chat with my sales team first?
              </p>

              <svg
                width="42"
                height="26"
                viewBox="0 0 42 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  position: "absolute",
                  top: "-40px",
                  left: "-40px",
                  transform: "rotate(15deg)",
                }}
              >
                <path
                  d="M16.4074 7.34175C17.7038 7.88943 17.5756 6.70574 17.9385 6.21377C19.5153 4.07565 20.7912 1.67482 23.5673 0.736103C27.1561 -0.477465 29.8545 1.26986 30.3774 5.21398C30.4729 5.93439 30.2683 6.70288 30.7877 7.53173C33.3631 7.30866 35.3494 5.59276 37.7287 4.76796C37.4007 3.80853 36.1182 4.20992 35.8307 3.08599C37.7741 2.06871 39.667 3.2299 41.5537 3.3193C41.925 3.33691 42.0931 3.89602 41.9483 4.24146C41.1034 6.25805 40.0874 8.16821 38.488 9.66151C37.2811 8.91718 38.1036 7.97954 37.7964 7.27414C33.3014 7.51292 30.4658 9.91792 29.4206 14.067C28.47 17.8413 26.496 21.1254 23.4473 23.5576C20.0032 26.3052 16.5039 24.6068 13.1602 23.1062C11.8866 22.5347 10.7826 21.5885 9.45428 20.7166C7.01958 21.8678 4.4655 23.066 1.92159 24.2854C1.3313 24.5683 0.692098 25.1722 0.227405 24.2712C-0.163965 23.5123 0.436962 23.0316 1.05392 22.6837C3.05491 21.5553 5.06212 20.4378 7.1917 19.2463C5.86891 16.8457 3.55704 15.3161 2.72753 12.7887C2.40434 11.8039 1.90484 10.8814 1.82315 9.81793C1.59254 6.81859 2.73543 4.343 4.83534 3.35013C7.56728 2.05847 11.7122 2.60651 13.8946 4.62309C14.7666 5.42873 15.5113 6.37089 16.4077 7.34139L16.4074 7.34175ZM12.2185 5.28719C8.86363 3.61355 5.98541 3.74128 4.38691 5.63466C2.59955 7.75171 2.7578 10.1556 4.9144 13.4199C7.35557 17.1149 10.8143 19.7588 14.5574 21.9014C19.1472 24.5285 22.0338 23.619 24.9779 19.2421C25.3517 18.6864 25.8317 18.1859 26.1181 17.5908C27.0174 15.7233 28.3096 13.9597 28.1208 11.6295C26.0691 11.899 24.5982 12.9901 22.9514 13.6417C21.4426 14.2387 20.2305 16.0196 18.2596 15.1162C18.1907 14.2605 18.7432 14.092 19.1539 13.7974C21.1711 12.3509 23.4835 11.4743 25.7131 10.4442C28.8545 8.99301 29.5706 7.3452 28.4084 4.0422C27.5912 1.71969 25.7968 0.997029 23.6541 2.21119C22.1428 3.06765 21.0022 4.29812 20.0237 5.76476C18.7721 7.64053 18.0947 9.79043 16.9457 11.8422C15.8014 9.34845 14.5291 7.14141 12.2185 5.28719Z"
                  fill="black"
                />
              </svg>

              <h2>Did you lock up your heart and throw away the key?</h2>

              <p>
                If you forgot your subdomain (the bit before capsulecrm.com when
                you log in) it's no big deal.{" "}
                <Link
                  to="https://app.capsulecrm.com/siteaddress/find"
                  className="link"
                  target="_blank"
                >
                  Just click Forgotten your site address?
                </Link>{" "}
                and pop in your email. We'll be back together in no time.
              </p>

              <p>
                Don't worry if you've been keeping your things at someone else's
                contact management system – you can import your data from pretty
                much any CRM platform after you log in. I made it super easy for
                you &lt;3
              </p>

              <h2>Maybe we didn't communicate well enough last time?</h2>

              <p>
                If you really want to take this relationship to the next level,
                I wrote down some{" "}
                <Link
                  to="https://capsulecrm.com/blog/how-to-make-the-most-of-your-capsule-trial/"
                  className="link"
                  target="_blank"
                >
                  trial period tips you might like
                </Link>
                .
              </p>

              <svg
                width="26"
                height="29"
                viewBox="0 0 26 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  position: "absolute",
                  left: "-50px",
                  top: "50%",
                  transform: "translateY(-50%) rotate(-10deg)",
                }}
              >
                <path
                  d="M19.3748 0.813139C25.5371 2.7934 20.3056 9.11608 16.4332 14.3046C19.6315 14.1675 24.0052 14.5402 25.1573 17.5303C27.6675 24.0249 6.52029 28.3061 0.168524 28.3905C1.83233 17.4423 8.83411 -2.5774 19.3748 0.813139Z"
                  fill="#C8C5FE"
                />
              </svg>

              <p>
                Or you could join my next demo to really make the most of me.
              </p>

              <p>
                Just like Toni Braxton said,{" "}
                <Link
                  to="https://app.capsulecrm.com/siteaddress/goto"
                  className="link"
                  target="_blank"
                >
                  un-break my heart — say you'll log in again
                </Link>
                .
              </p>

              <svg
                width="65"
                height="67"
                viewBox="0 0 65 67"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  position: "absolute",
                  bottom: "0px",
                  right: "-40px",
                  transform: "rotate(15deg)",
                }}
              >
                <path
                  d="M34.3178 38.2072C34.3178 38.2072 12.9774 25.4495 20.5876 11.1117C25.4436 1.96643 34.4666 -1.32392 41.6915 2.51279C58.2065 11.281 42.35 42.472 63.9921 53.9618C42.35 42.472 25.3947 73.0781 8.88174 64.3079C1.65682 60.4711 -0.673334 51.1525 4.18269 42.0072C11.7929 27.6736 34.3178 38.2072 34.3178 38.2072Z"
                  stroke="#C8C5FE"
                  stroke-width="1.72984"
                  stroke-miterlimit="10"
                />
              </svg>

              <svg
                width="25"
                height="27"
                viewBox="0 0 25 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  position: "absolute",
                  bottom: "-20px",
                  left: "-40px",
                  transform: "rotate(15deg)",
                }}
              >
                <path
                  d="M18.8357 9.40527C20.0124 9.87366 19.3961 10.8205 19.7087 11.4512C20.6014 13.2519 21.4878 15.0058 23.7468 15.3799C24.2976 15.4711 24.8048 15.6369 24.8308 16.3145C24.8525 16.8802 24.3886 17.1136 23.9783 17.2461C21.5122 18.042 21.0051 20.0311 20.8806 22.2539C20.8093 23.5273 20.7268 24.7887 19.8767 26.1709C18.0674 24.6387 19.0081 22.3803 18.0613 20.7246C16.9633 18.8051 14.9446 18.5441 13.2615 17.4404C14.218 16.0198 15.6301 15.4139 16.8933 14.3838C18.6154 13.0789 17.8725 10.9016 18.8357 9.40527ZM21.7029 16.3643C20.6489 15.8295 20.2887 14.4899 18.6462 14.7734L18.4089 15.041C17.828 15.647 17.1008 16.1565 16.99 17.1289C17.9545 17.9594 18.9074 18.78 19.8601 19.6006C20.1054 18.5695 21.0463 17.6534 21.7029 16.3643ZM6.01831 0C7.195 0.46829 6.57903 1.4152 6.89136 2.0459C7.78406 3.84663 8.67042 5.60055 10.9294 5.97461C11.4802 6.06585 11.9873 6.23182 12.0134 6.90918C12.0352 7.47499 11.5712 7.70831 11.1609 7.84082C8.69493 8.63665 8.18773 10.6259 8.06323 12.8486C7.99194 14.122 7.9093 15.3835 7.05933 16.7656C5.25021 15.2334 6.19083 12.975 5.2439 11.3193C4.14591 9.3999 2.12717 9.13884 0.444092 8.03516C1.40058 6.61484 2.8129 6.00943 4.07593 4.97949C5.79809 3.67455 5.05502 1.49634 6.01831 0ZM8.8855 6.95996C7.8313 6.42524 7.47138 5.0846 5.82886 5.36816L5.59155 5.63574C5.01064 6.2418 4.28346 6.75112 4.17261 7.72363C5.13711 8.55417 6.09002 9.37475 7.04272 10.1953C7.288 9.16433 8.22896 8.24895 8.8855 6.95996Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>
        </div>

        {showModal && (
          <div className="i-miss-you-modal">
            <div
              className="i-miss-you-modal__backdrop"
              onClick={() => setShowModal(false)}
            />
            <div className="i-miss-you-modal__window">
              <button
                className="i-miss-you-modal__close"
                onClick={() => setShowModal(false)}
                aria-label="Close modal"
              >
                <Close />
              </button>
              <div className="i-miss-you-modal__content">
                <iframe
                  style={{ borderRadius: "12px" }}
                  src="https://open.spotify.com/embed/playlist/4AnEmrP0ViCLc43EMvjsRT?utm_source=generator"
                  width="100%"
                  height="352"
                  frameBorder="0"
                  allowFullScreen=""
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        )}

        <footer className="simple-footer">
          <h2>Sealed with a kiss.</h2>
          <p>
            I’ll keep you in my heart. And all over my diary. <br /> Love you
            always, Capsule CRM.
          </p>
          <div className="button-group">
            <Link
              to="https://app.capsulecrm.com/siteaddress/goto"
              className="button primary mb-4"
              target="_blank"
            >
              Log back in
            </Link>
            <Link to="/contact-sales" className="button secondary mr-2 mb-4">
              or talk to Sales
            </Link>
          </div>
        </footer>
      </div>
    </MainLayout>
  )
}

export default IMissYouPage

export const query = graphql`
  query {
    ...Locales
    jiltedImages: allFile(
      filter: {
        sourceInstanceName: { eq: "images" }
        relativeDirectory: { eq: "campaign/jilted-lover" }
      }
    ) {
      edges {
        node {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`
